import React from 'react';
import { C, DISP, BODY, MONO, FadeUp, track, scrollToId, useSectionView } from './shared';
import { DailyGrowthPlan } from './DailyGrowthPlan';

export const HeroSection = () => {
  const ref = useSectionView('hero');

  return (
    <section ref={ref} style={{
      position: 'relative',
      padding: 'clamp(120px, 16vh, 180px) clamp(20px, 5vw, 48px) clamp(60px, 8vw, 100px)',
      overflow: 'hidden',
      background: `
        radial-gradient(ellipse 60% 45% at 22% 18%, rgba(200,241,53,0.10), transparent 70%),
        radial-gradient(ellipse 50% 40% at 82% 65%, rgba(80,140,255,0.06), transparent 70%),
        linear-gradient(180deg, #080d04 0%, ${C.bg} 100%)
      `,
    }}>
      <div aria-hidden="true" style={{
        position: 'absolute', inset: 0, pointerEvents: 'none',
        backgroundImage: 'linear-gradient(rgba(200,241,53,0.045) 1px, transparent 1px), linear-gradient(90deg, rgba(200,241,53,0.045) 1px, transparent 1px)',
        backgroundSize: '72px 72px',
        maskImage: 'radial-gradient(ellipse 80% 70% at 50% 30%, black, transparent)',
        WebkitMaskImage: 'radial-gradient(ellipse 80% 70% at 50% 30%, black, transparent)',
      }} />

      <div className="scl-hero-grid" style={{ position: 'relative', maxWidth: 1200, margin: '0 auto', display: 'grid', gridTemplateColumns: '1.1fr 0.9fr', gap: 56, alignItems: 'center' }}>
        <div>
          <FadeUp delay={0}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '7px 14px', borderRadius: 999, border: `1px solid ${C.borderLime}`, background: 'rgba(200,241,53,0.05)', marginBottom: 28 }}>
              <span className="scl-pulse-dot" style={{ width: 6, height: 6, borderRadius: '50%', background: C.lime }} />
              <span style={{ fontFamily: MONO, fontSize: 10.5, letterSpacing: '0.18em', color: C.lime, textTransform: 'uppercase' }}>Marketing operating system for founders</span>
            </div>
          </FadeUp>

          <FadeUp delay={100}>
            <h1 style={{ fontFamily: DISP, fontWeight: 800, fontSize: 'clamp(38px, 6.2vw, 76px)', letterSpacing: '-0.03em', lineHeight: 1.02, color: C.text }}>
              Run your marketing like you have <span style={{ color: C.lime }}>a team.</span>
            </h1>
          </FadeUp>

          <FadeUp delay={200}>
            <p style={{ marginTop: 26, fontFamily: BODY, fontSize: 17.5, lineHeight: 1.75, color: C.body, maxWidth: 520 }}>
              ScalitOS studies your business, identifies the highest-impact thing to market next, and helps you turn it into ready-to-launch content, campaigns, emails and ads.
            </p>
          </FadeUp>

          <FadeUp delay={300}>
            <div className="scl-hero-ctas" style={{ marginTop: 36, display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'center' }}>
              <button
                data-testid="hero-cta"
                className="scl-btn-primary"
                onClick={() => { track('hero_cta_clicked'); scrollToId('scanner'); }}
              >
                Scan my brand free →
              </button>
              <button
                data-testid="hero-secondary-cta"
                className="scl-btn-ghost"
                onClick={() => { track('hero_secondary_cta_clicked'); scrollToId('campaign-demo'); }}
              >
                See a campaign example
              </button>
            </div>
          </FadeUp>

          <FadeUp delay={380}>
            <p style={{ marginTop: 20, fontFamily: BODY, fontSize: 13.5, color: C.muted }}>
              No card required &middot; Start with a plan built around your business
            </p>
          </FadeUp>
        </div>

        <FadeUp delay={250} style={{ width: '100%' }}>
          <DailyGrowthPlan />
        </FadeUp>
      </div>
    </section>
  );
};
